import type { User } from "@auth/me.query"
import { SYSADMIN_ROLE } from "@utils/roles"

export const ERRORS_API_BASE = (
  import.meta.env.VITE_ERROR_LOGGER_URL ?? ""
).replace(/\/+$/u, "")

export const canViewErrors = (user: Pick<User, "roles">): boolean =>
  ERRORS_API_BASE !== "" && user.roles.includes(SYSADMIN_ROLE)
